/**
 * Article Page Component - Individual Article Content Display
 * 
 * Author: Markus van Kempen - markus.van.kempen@gmail.com
 * Last Updated: January 2025
 * Version: 1.0.0
 */

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import './ArticlePage.css';

const ArticlePage = () => {
  const { category, page } = useParams();
  const navigate = useNavigate();
  
  console.log('ArticlePage mounted with params:', { category, page });

  useEffect(() => {
    // Redirect to the page viewer using the page ID
    if (page) {
      navigate(`/page/${page}`, { replace: true });
    } else {
      navigate('/articles', { replace: true });
    }
  }, [category, page, navigate]);

  return (
    <div className="article-page-container">
      <LoadingSpinner message="Redirecting to article..." />
    </div>
  );
};

export default ArticlePage;
